<template>
    <div class="c-calendar-filter c-calendar-filter__event-type">
        <label class="u-hidden-visually">Filter by event type</label>
        <button type="button" 
                class="c-btn" 
                :class="isShowsSelected"
                @click="chosenValue('shows')">Shows</button>
        <button type="button" 
                class="c-btn" 
                :class="isOtherSelected"
                @click="chosenValue('other')">Other Offerings</button>
    </div>
</template>

<script>
    import {EventBus} from "../event-bus"

    export default {
        name: "EventTypeFilter",
        data() {
            return {
                selected: ''
            }
        },
        mounted() {
            EventBus.$on('clearFilters', this.resetFilter)
        },
        computed: {
            isShowsSelected() {
                return this.selected === 'shows' ? 'c-btn--primary' : 'c-btn--secondary'
            },
            isOtherSelected() {
                return this.selected === 'other' ? 'c-btn--primary' : 'c-btn--secondary'
            }
        },
        methods: {
            chosenValue(type) {
                if (type !== this.selected) {
                    this.selected = type
                    EventBus.$emit('updateEventFilters', 'type', type)
                }
            },
            resetFilter() {
                this.selected = '';
            }
        }
    }
</script>

<style>
    @import '~vue-select/dist/vue-select.css';
</style>
